import {useClientEnabledFeatures} from '#/hooks/query/use-client-enabled-features';
import {DefaultChildren} from '#/utils/utils';
import {createContext, FunctionComponent} from 'react';

export interface ClientEnabledFeaturesContextValue {
  transferWallet: boolean;
  importWallet: boolean;
}

const initialValue: ClientEnabledFeaturesContextValue = {
  transferWallet: false,
  importWallet: false,
} as const;

export const ClientEnabledFeaturesContext = createContext<ClientEnabledFeaturesContextValue>(initialValue);

export const ClientEnabledFeaturesProvider: FunctionComponent<DefaultChildren> = ({children}) => {
  const {data: clientEnabledFeatures = []} = useClientEnabledFeatures();

  const value = {
    transferWallet: clientEnabledFeatures.includes('transferWallet'),
    importWallet: clientEnabledFeatures.includes('importWallet'),
  };

  return <ClientEnabledFeaturesContext.Provider value={value}>{children}</ClientEnabledFeaturesContext.Provider>;
};
